import React, { useState, useContext, useEffect } from "react";
import { withTranslation } from "react-i18next";

// MUI
import DialogActions from "@mui/material/DialogActions";

import DraggableDialog from "@/ui/Dialog/DraggableDialog";
import DialogBody from "@/ui/Dialog/DialogBody";
import DialogActionButtonClose from "@/ui/Dialog/ActionButtons/DialogActionButtonClose";

import api from "@/lib/api";
import arrayBufferToBase64 from "@/lib/arrayBufferToBase64";

import DialogContext from "@/ui/DialogContext/DialogContext";
import { Box } from "@mui/material";

interface SingleImageViewerProps {
  image: any;
  path: string;
  level: number;
}

function SingleImageViewer(props: SingleImageViewerProps) {
  const dialogContext = useContext(DialogContext);

  const [imageContent, setImageContent] = useState<string | null>(null);
  const { image, path, level } = props;

  const apiInstance = new api();

  useEffect(() => {
    const customPath = path ? path : "images";
    const url = `${customPath}/${image.uuid}`;

    if (image.hasOwnProperty("content") && image.content) {
      setImageContent(image.content);
    } else {
      apiInstance.Call(url, "get").then((resp) => {
        //@ts-ignore
        if (resp.data && resp.data.image) {
          //@ts-ignore
          setImageContent(resp.data.image);
        }
        // resp.arrayBuffer().then(data => {
        //   const imageB64 = arrayBufferToBase64(data);
        //   setImageContent(imageB64)
        // })
      });
    }
  }, []);

  const handleClose = () => {
    if (level === 2) {
      dialogContext.hideDialog(2);
    } else {
      dialogContext.hideDialog();
    }
  };

  return (
    <DraggableDialog open={true} maxWidth={"md"} onClose={handleClose}>
      <Box sx={{ marginTop: 3 }}>
        <DialogBody>
          {imageContent ? (
            <img
              src={`data:image/jpeg;base64, ${imageContent}`}
              width="100%"
              height="100%"
            />
          ) : null}
        </DialogBody>
      </Box>
      <DialogActions>
        <DialogActionButtonClose variant="contained" onClick={handleClose} />
      </DialogActions>
    </DraggableDialog>
  );
}

export default withTranslation()(SingleImageViewer);
